export enum CustomerTypeEnum {
    Energy = 1,
    Water = 2
}